import React from "react";

function BookItem(props) {
  return (
    <>
      <li className="cards__item">
        <a className="cards__item__link" href={props.path}>
          <figure className="cards__item__pic-wrap" data-category={props.label}>
            <img
              className="cards__item__img"
              alt=""
              src={props.src}
              style={{
                // filter: "grayscale(0%) brightness(100%) contrast(100%)",
                objectFit: "contain",
              }}
            />
          </figure>
          <div className="cards__item__info">
            <h5 className="cards__item__text" style={{ fontColor: "black" }}>
              {props.title}
            </h5>
            {props.subtitle !== "" && (
              <p
                className="cards__item__sub__text"
                style={{ fontColor: "black" }}
              >
                {props.subtitle}
              </p>
            )}
          </div>
        </a>
      </li>
    </>
  );
}

export default BookItem;
